import { strings } from '@constants'
class EnquirySupplierQuote {
	constructor() {
		this.supplier = null
		this.dispatch_location = null
		this.billing_address = null
		this.order_given = false
		this.quote_type = strings('for') //x or for
		this.minimum_order_quantity = 0
		this.minimum_guaranteed_weight = 0
		this.quote_valid_till = new Date().getTime()
		this.logistics_quote = 0
		this.total_quotation_amount = 0
		this.supplier_quote = []
		this.message = null
		this.lumpsum_logistics_quote = 0
		this.by_admin = true
		this.quote_accepted_buyer = null
		this.quote_accepted_supplier = null
		this.is_requested_supplier = null
		this.billing_address = null
		this.payment_terms_list = null
		this.other_charges = null
		this.show_buyer_name = false
		this.terms = `We declare that this invoice shows the actual price of the goods and all the particulars are true and correct.\n1. Interest upto 24% p.a. will be charged after a grace period of 7 days if the payment is not received as per the payment terms.\n2. Risk is transferred on delivery of goods to the party.\n3. All disputes are subject to Delhi Jurisdiction only.\n4. Weight Tolerance :- +/- 0.5% OF Invoiced Weight Visit www.metalbook.app / Download Metalbook app (Download App) to track your current order, see past invoices and orders with Metalbook, ledger and other details. COMPANY'S BANK DETAILS BANK NAME : Standard Chartered Bank A/C NO : 53105141407 IFSC CODE : SCBL0036025`
		// '1. PRICES ARE F.O.R AT SITE AND EXCLUSIVE OF TAXES\n2. ENDORSED TEST CERTIFICATES TO BE PROVIDED BEFORE DISPATCH\n3. WEIGHT TOLERANCE :- +/- 0.5% OF INVOICED WEIGHT\n4. DELIVERY CONDITIONS :- IMMEDIATE\n5. TCS IS NOT APPLICABLE, TDS TO BE CHARGED WHILE MAKING THE PAYMENT AGAINST THE BILLS.\n6. UNLOADING EXTRA UNDER THE SCOPE OF THE BUYER\n'
		this.oracle_order_in_kgs = false
		this.expected_delivery_date = null
		this.dispatch_start_date = null
		this.expected_transit_time = null
	}
}
// `We declare that this invoice shows the actual price of the goods and all the particulars are true and correct.\n
// 1.Interest upto 24% p.a. will be charged after a grace period of 7 days if the payment is not received as per the payment terms\n
// 2.Risk is transferred on delivery of goods to the party\n
// 3.All disputes are subject to Delhi Jurisdiction only\n
// 4.Weight Tolerance :- +/- 0.5% OF Invoiced Weight Visit www.metalbook.app / Download Metalbook app (Download App) to track your current order, see past invoices and orders with Metalbook, ledger and other details. COMPANY'S BANK DETAILS BANK NAME : Standard Chartered Bank A/C NO : 53105141407 IFSC CODE : SCBL0036025`

export default EnquirySupplierQuote
